
import Swiper from 'swiper'
import 'swiper/css/swiper.css'

export default {
  props: {
    images: {
      type: Array,
      default: () => {
        return []
      }
    },
    options: {
      type: Object,
      default: () => ({
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: false
      })
    }
  },
  data() {
    return {
      swiper: null,
      paginationSwiper: null,
      currentSlide: 0,
      isUpdating: false // Флаг для предотвращения рекурсии
    }
  },
  mounted() {
    this.initSwiper()
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true)
    }
    if (this.paginationSwiper) {
      this.paginationSwiper.destroy(true, true)
    }
  },
  methods: {
    initSwiper() {
      if (this.images && this.images.length > 1) {
        this.$nextTick(() => {
          // Основной слайдер
          const mainOptions = {
            ...this.options,
            on: {
              slideChange: () => {
                if (this.isUpdating) return
                this.isUpdating = true
                this.currentSlide = (this.swiper?.realIndex || 0)
                // Синхронизация с пагинационным слайдером
                if (this.paginationSwiper) {
                  this.paginationSwiper.slideToLoop(this.currentSlide)
                }
                this.$nextTick(() => {
                  this.isUpdating = false
                })
              }
            }
          }
          this.swiper = new Swiper(this.$refs.swiperContainer, mainOptions)

          // Пагинационный слайдер
          const paginationOptions = {
            slidesPerView: 'auto',
            spaceBetween: 4,
            centeredSlides: false,
            freeMode: false,
            watchSlidesProgress: true,
            on: {
              slideChange: () => {
                if (this.isUpdating) return
                this.isUpdating = true
                // Синхронизация с основным слайдером при свайпе пагинации
                if (this.paginationSwiper && this.swiper) {
                  const activeIndex = this.paginationSwiper.realIndex
                  this.currentSlide = activeIndex
                  this.swiper.slideToLoop(activeIndex)
                }
                this.$nextTick(() => {
                  this.isUpdating = false
                })
              }
            }
          }
          this.paginationSwiper = new Swiper(this.$refs.paginationSwiperContainer, paginationOptions)
        })
      }
    },
    openPopUpImages() {
      // Метод для открытия попапа с изображениями
      // Можно добавить логику открытия модального окна
      this.$emit('open-popup', this.images)
    },
    // Методы для внешнего управления слайдером
    slideNext() {
      if (this.swiper) {
        console.log('this.swiper: ', this.swiper)
        this.swiper.slideNext()
        this.$nextTick(() => {
          this.currentSlide = this.swiper.realIndex
        })
      }
    },
    slidePrev() {
      if (this.swiper) {
        this.swiper.slidePrev()
        // Обновляем currentSlide после переключения
        this.$nextTick(() => {
          this.currentSlide = this.swiper.realIndex
        })
      }
    },
    slideTo(index) {
      if (this.isUpdating) return
      this.isUpdating = true

      // Обновляем текущий слайд
      this.currentSlide = index

      if (this.swiper) {
        this.swiper.slideToLoop(index)
      }
      if (this.paginationSwiper) {
        this.paginationSwiper.slideToLoop(index)
      }

      this.$nextTick(() => {
        this.isUpdating = false
      })
    }
  },
  watch: {
    images: {
      handler() {
        this.$nextTick(() => {
          if (this.swiper) {
            this.swiper.destroy(true, true)
          }
          if (this.paginationSwiper) {
            this.paginationSwiper.destroy(true, true)
          }
          this.initSwiper()
        })
      },
      deep: true
    }
  },
  computed: {
    shouldShowSlider() {
      return this.images && this.images.length > 1
    }
  }
}
